import React from "react";
import { motion } from "framer-motion";
import { trackLead } from "../../lib/track";

const TELEGRAM_URL = "https://t.me/+cr1LhxIMB-5jODJl";

const Stat = ({ label, value, sub }) => (
  <div className="flex flex-col">
    <span className="font-display text-[36px] md:text-[44px] text-white tracking-tight leading-none">
      {value}
    </span>
    <span className="mt-2 text-[10px] tracking-[0.3em] uppercase text-white/40">{label}</span>
    {sub && <span className="mt-1 text-[11px] text-white/40">{sub}</span>}
  </div>
);

const VipSection = () => {
  return (
    <section id="vip" className="relative py-28 md:py-36">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.2, 0.7, 0.2, 1] }}
          className="relative overflow-hidden rounded-[32px] glass-panel"
          data-testid="vip-section"
        >
          {/* atmospheric layers */}
          <div className="absolute inset-0 -z-0 pointer-events-none">
            <div className="absolute -top-40 -left-20 h-[420px] w-[420px] rounded-full bg-[rgba(78,168,255,0.20)] blur-3xl" />
            <div className="absolute -bottom-40 -right-20 h-[460px] w-[460px] rounded-full bg-[rgba(31,111,224,0.18)] blur-3xl" />
            <div className="absolute inset-0 opacity-[0.05] [background-image:linear-gradient(rgba(255,255,255,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.5)_1px,transparent_1px)] [background-size:80px_80px] [mask-image:radial-gradient(ellipse_50%_60%_at_50%_50%,black,transparent_70%)]" />
            {/* horizon arc inside */}
            <div className="absolute left-1/2 -translate-x-1/2 bottom-[-60%] h-[120%] w-[140%] rounded-full border border-[#4ea8ff]/20 shadow-[0_0_80px_rgba(78,168,255,0.18)_inset]" />
          </div>

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 px-7 sm:px-12 md:px-16 py-16 md:py-24">
            <div className="lg:col-span-7 flex flex-col">
              <span className="inline-flex items-center gap-2.5 self-start rounded-full border border-[#4ea8ff]/30 bg-[#4ea8ff]/[0.06] px-3.5 py-1.5 text-[10.5px] tracking-[0.3em] uppercase text-[#cfe6ff]">
                <span className="h-1.5 w-1.5 rounded-full bg-[#4ea8ff] shadow-[0_0_10px_#4ea8ff]" />
                Members Only
              </span>

              <h2 className="mt-7 font-display text-[44px] sm:text-[60px] md:text-[76px] leading-[1] tracking-[-0.035em]">
                <span className="text-gradient-silver">BIGBULL</span>{" "}
                <span className="text-gradient-blue">VIP</span>
              </h2>

              <p className="mt-7 max-w-[520px] text-[16px] md:text-[18px] text-white/65 font-light leading-relaxed">
                Advanced Quotex signals and structured OTC binary sessions for serious
                traders. Direct mentorship, refined risk frameworks, and second-perfect
                entries — delivered to a closed circle.
              </p>

              <div className="mt-10 flex flex-wrap items-center gap-4">
                <a
                  href={TELEGRAM_URL}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => trackLead("vip")}
                  className="btn-pill btn-primary-blue"
                  data-testid="vip-cta"
                >
                  Join VIP
                  <span aria-hidden>→</span>
                </a>
                <span className="text-[11px] tracking-[0.28em] uppercase text-white/40">
                  Limited Seats · Onboarding via Telegram
                </span>
              </div>
            </div>

            <div className="lg:col-span-5 grid grid-cols-2 gap-y-10 gap-x-6 lg:pl-8 lg:border-l lg:border-white/[0.06]">
              <Stat label="Avg Win-Rate" value="82%" sub="Last 90 days" />
              <Stat label="Daily Setups" value="6–10" sub="Curated only" />
              <Stat label="Avg Session" value="4.8%" sub="Compounded" />
              <Stat label="Active Members" value="1.2K+" sub="And growing" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VipSection;
